// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialNetworksAuthButtons_wrapper__KS_hs","button":"SocialNetworksAuthButtons_button__R9nU7"};